import { useMatches } from "react-router";

import { createBreadcrumbs } from "src/convenience/breadcrumbs";

export function useBreadcrumbs() {
  const matches = useMatches();
  return createBreadcrumbs(matches);
}
